import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden ${className}`} {...props} data-id="element-145">
      <div className={noPadding ? '' : 'p-4'} data-id="element-146">{children}</div>
    </div>;
}